export default "__VITE_ASSET__CaalyrT3__"